// extracted by mini-css-extract-plugin
module.exports = {"MainStructure":"MainStructure_MainStructure__2bHjb"};